<template>
    <div>

        <div class="flex items-baseline">
            <h3 class="text-2xl mt-2 mb-8 truncate">Hits & Misses</h3>
            <span class="ml-auto text-grey truncate"># Reviews</span>
        </div>
        
        <div class="">

            <ship-review-overall-hits-misses-item
                label="top_1"
                :ship="ship"
            />
            <ship-review-overall-hits-misses-item
                label="top_2"
                :ship="ship"
            />
            <ship-review-overall-hits-misses-item
                label="top_3"
                :ship="ship"
            />
            <!--<ship-review-overall-hits-misses-item
                label="top_4"
                :ship="ship"
            />
            <ship-review-overall-hits-misses-item
                label="top_5"
                :ship="ship"
            />-->
        </div>
        <div class="mt-4">
            <ship-review-overall-hits-misses-item
                label="flop_1"
                :ship="ship"
            />
            <ship-review-overall-hits-misses-item
                label="flop_2"
                :ship="ship"
            />
            <ship-review-overall-hits-misses-item
                label="flop_3"
                :ship="ship"
            />
            <!--
            <ship-review-overall-hits-misses-item
                label="flop_4"
                :ship="ship"
            />
            <ship-review-overall-hits-misses-item
                label="flop_5"
                :ship="ship"
            />
            -->


        </div>

    </div>

</template>

<script>
import ShipReviewOverallHitsMissesItem from "@/components/cat/ShipReviewOverallHitsMissesItem.vue";

export default {
    props: {
        ship: {
            type: Object,
            required: true
        }
    },
    components: {
        ShipReviewOverallHitsMissesItem
    }
}
</script>